import React, { Component } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import ReportsDashboardOne from "./reportsDashboard/ReportsDashboardOne";

export class SuperAdminReportsMain extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="Reports" />
              <div className="super-admin-reports-section">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-0 bottom-side-panel-reports">
                  <ReportsDashboardOne />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SuperAdminReportsMain;
